// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"fZ-z","subtitle":"gZ-z","wrapper":"hZ-z","leftArrow":"iZ-z","rightArrow":"jZ-z"};